import axios from "axios";

export async function getAllBg() {
  const cachedData = localStorage.getItem("bgData");
  const cachedETag = localStorage.getItem("ETag");
  try {
    let response = await axios.get(
      `${process.env.SERVER_BASE_URL}/durga-puja-2025/bg/get-all`,
      {
        headers:
          cachedETag && cachedData ? { "If-None-Match": cachedETag } : {},
        validateStatus: (status) =>
          (status >= 200 && status < 300) || status === 304,
      }
    );

    if (response.status === 200) {
      localStorage.setItem(
        "bgData",
        JSON.stringify(response?.data?.backgrounds)
      );
      localStorage.setItem("ETag", response.headers["etag"]);
      return response?.data?.backgrounds;
    } else if (response.status === 304 && cachedData) {
      let backgrounds = JSON.parse(cachedData);
      return backgrounds;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
